import { delay1diib1rb84y4j as delay } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Delay.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  httpHeaders1p0c4h1mvk3o7 as httpHeaders,
  websocket1qipdxwrf95zh as websocket,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.js.mjs';
import {
  _Char___init__impl__6a9atx2js6krycynjoo as _Char___init__impl__6a9atx,
  toString3o7ifthqydp6e as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  contains2el4s70rdq4ld as contains,
  substringBefore3n7kj60w69hju as substringBefore,
  substringAfter1hku067gwr5ve as substringAfter,
  split3d3yeauc4rm2n as split,
  substringAfter35b3qhto7hchb as substringAfter_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { joinToString1cxrrlmo0chqs as joinToString } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { Companion_getInstance3n9as6ds1py67 as Companion_getInstance } from '../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import {
  BulkRequest1ynbxhwj3d4b2 as BulkRequest,
  Companion_instancedr8ewd9slv0o as Companion_instance,
  BulkResponsenhuw5ggnccvl as BulkResponse,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/typed/BulkRequest.mjs';
import { get_AppScopes4bqeg21n0qw as get_AppScope } from '../../../../../reactive/com/lightningkite/reactive/core/AppScope.mjs';
import { launch1c91vkjzdi9sd as launch } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Builders.common.mjs';
import {
  intercepted2ogpsikxxj4u0 as intercepted,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { returnIfSuspendedqak8u4r448cu as returnIfSuspended } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coroutineInternalJS.mjs';
import { toShort36kaw0zjdq3ex as toShort } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { LsErrorException1ikb4g50zc2ko as LsErrorException } from '../LsErrorException.mjs';
import { LSError2xrpo13ez2d1 as LSError } from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/LSError.mjs';
import {
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  serializer1x79l67jvwntn as serializer_0,
  MapSerializer11kmegt3g5c1g as MapSerializer,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import {
  HttpMethod_POST_getInstance3c6ouf174z7cx as HttpMethod_POST_getInstance,
  RequestBodyTextpvofjwd95b3y as RequestBodyText,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import { StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { connectivityFetch3ow9vj797ywad as connectivityFetch } from '../../../../../kiteui-library/com/lightningkite/kiteui/fetch-connectivity.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  createKType31ecntyyaay3k as createKType,
  createInvariantKTypeProjection3h5364czc0a8w as createInvariantKTypeProjection,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer_1 } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  Companion_instance2oawqq9qiaris as Companion_instance_0,
  _Result___init__impl__xyqfz83hut4nr3dfvi3 as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  Exceptiondt2hlxn7j7vw as Exception,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { Job13y4jkazwjho0 as Job } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Job.mjs';
import {
  CoroutineScopelux7s7zphw7e as CoroutineScope,
  cancel36mj9lv3a0whl as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope_0,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import {
  MultiplexMessage1yepwrh5ltbje as MultiplexMessage,
  Companion_getInstance4nebw1aefgxh as Companion_getInstance_0,
} from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/websocket/MultiplexMessage.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { get_DefaultJson7vbyrb403mrj as get_DefaultJson } from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/urls.mjs';
import {
  Companion_getInstance3vz87v4c01z2t as Companion_getInstance_1,
  toDuration7gy6v749ektt as toDuration,
  _Duration___get_inWholeMilliseconds__impl__msfiry1byvgyrhm5g4a as _Duration___get_inWholeMilliseconds__impl__msfiry,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  retryWebsocket1x6ytgxxp3whc as retryWebsocket,
  typed3v04bxztitnhl as typed,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/wsretry.mjs';
import {
  get_debugMode2ku08uo1anfv as get_debugMode,
  report1vfr9zf0i9d9p as report,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/debugger.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { take9j4462mea726 as take } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/_Strings.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$launch, $completion) {
  var tmp = delay($this.deq_1.xep_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = fetch($this.deq_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = $this.eeq_1.zep_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return httpHeaders(tmp);
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = $this.feq_1.zep_1($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var headers = tmp;
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!headers.i1()) {
    var terminator = contains($this.feq_1.uep_1, _Char___init__impl__6a9atx(63)) ? _Char___init__impl__6a9atx(38) : _Char___init__impl__6a9atx(63);
    var tmp_1 = toString(terminator);
    tmp_0 = $this.feq_1.uep_1 + (tmp_1 + joinToString(headers, '&', VOID, VOID, VOID, VOID, BulkFetcher$remember$slambda$lambda));
  } else {
    tmp_0 = $this.feq_1.uep_1;
  }
  var url = tmp_0;
  return websocket(url);
}
function BulkFetcher$remember$slambda$lambda(it) {
  return it.af_1 + '=' + it.bf_1;
}
function *_generator_invoke__zhh2q8_2($this, url, method, inSerializer, body, outSerializer, $completion) {
  var id = Companion_getInstance().m2p().toString();
  var req = new (BulkRequest())(url, method.a4_1, !(inSerializer.az().h10() === 'kotlin.Unit') ? $this.vep_1.x27(inSerializer, body) : null);
  if (!$this.beq_1) {
    $this.beq_1 = true;
    var tmp = get_AppScope();
    launch(tmp, VOID, VOID, BulkFetcher$invoke$slambda_0($this));
  }
  // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
  // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
  var cancellable = new (CancellableContinuationImpl())(intercepted($completion), 1);
  cancellable.ra5();
  $this.aeq_1.s3(id, to(req, cancellable));
  var tmp$ret$1 = cancellable.sa5();
  var tmp_0 = returnIfSuspended(tmp$ret$1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.let' call
  var it = tmp_0;
  var tmp_1;
  if (it.r4p_1 == null && outSerializer.az().h10() === serializer(Unit_instance).az().h10()) {
    tmp_1 = !(Unit_instance == null) ? Unit_instance : THROW_CCE();
  } else if (!(it.q4p_1 == null)) {
    tmp_1 = $this.vep_1.y27(outSerializer, ensureNotNull(it.q4p_1));
  } else {
    var tmp0_safe_receiver = it.r4p_1;
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.q4b_1;
    var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toShort(tmp1_safe_receiver);
    var tmp_2 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
    var tmp3_elvis_lhs = it.r4p_1;
    throw LsErrorException().bei(tmp_2, tmp3_elvis_lhs == null ? new (LSError())(0) : tmp3_elvis_lhs);
  }
  return tmp_1;
}
function *_generator_fetch__osg116($this, $completion) {
  var todo = $this.aeq_1;
  $this.aeq_1 = HashMap().n8();
  $this.beq_1 = false;
  try {
    var tmp = HttpMethod_POST_getInstance();
    var tmp_0 = BulkFetcher$fetch$slambda_0($this);
    var tmp_1 = MapSerializer(serializer_0(StringCompanionObject_instance), Companion_instance.m2a());
    // Inline function 'kotlin.collections.mapValues' call
    // Inline function 'kotlin.collections.mapValuesTo' call
    var destination = LinkedHashMap().fc(mapCapacity(todo.p1()));
    // Inline function 'kotlin.collections.associateByTo' call
    var _iterator__ex2g4s = todo.d2().m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      var tmp_2 = element.e2();
      var tmp$ret$1 = element.f2().af_1;
      destination.s3(tmp_2, tmp$ret$1);
    }
    var tmp_3 = connectivityFetch($this.tep_1, tmp, tmp_0, new (RequestBodyText())($this.vep_1.x27(tmp_1, destination), 'application/json'), $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    // Inline function 'kotlin.let' call
    var it = tmp_3;
    if (!it.gdo()) {
      var tmp_4 = it.jcx().toString() + ': ';
      var tmp_5 = it.hdo($completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      var failed = Exception().ud(tmp_4 + tmp_5);
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = todo.r3().m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_0 = element_0.bf_1;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$5 = _Result___init__impl__xyqfz8(createFailure(failed));
        this_0.rc(tmp$ret$5);
      }
    } else {
      var tmp0 = $this.vep_1;
      var tmp_6 = it.hdo($completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      // Inline function 'kotlinx.serialization.json.Json.decodeFromString' call
      var string = tmp_6;
      // Inline function 'kotlinx.serialization.serializer' call
      var this_1 = tmp0.mz();
      // Inline function 'kotlinx.serialization.internal.cast' call
      var this_2 = serializer_1(this_1, createKType(getKClass(KtMap()), arrayOf([createInvariantKTypeProjection(createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false)), createInvariantKTypeProjection(createKType(getKClass(BulkResponse()), arrayOf([]), false))]), false));
      var tmp$ret$10 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
      var responses = tmp0.y27(tmp$ret$10, string);
      // Inline function 'kotlin.collections.forEach' call
      // Inline function 'kotlin.collections.iterator' call
      var _iterator__ex2g4s_1 = todo.d2().m1();
      while (_iterator__ex2g4s_1.n1()) {
        var element_1 = _iterator__ex2g4s_1.o1();
        var tmp0_safe_receiver = responses.p3(element_1.e2());
        var tmp_7;
        if (tmp0_safe_receiver == null) {
          tmp_7 = null;
        } else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.coroutines.resume' call
          var this_3 = element_1.f2().bf_1;
          // Inline function 'kotlin.Companion.success' call
          var tmp$ret$13 = _Result___init__impl__xyqfz8(tmp0_safe_receiver);
          this_3.rc(tmp$ret$13);
          tmp_7 = Unit_instance;
        }
        if (tmp_7 == null) {
          var tmp0_0 = element_1.f2().bf_1;
          // Inline function 'kotlin.coroutines.resumeWithException' call
          // Inline function 'kotlin.Companion.failure' call
          var exception = Exception().ud('Bulk key ' + element_1.e2() + ' not found');
          var tmp$ret$17 = _Result___init__impl__xyqfz8(createFailure(exception));
          tmp0_0.rc(tmp$ret$17);
        }
      }
    }
  } catch ($p) {
    if ($p instanceof Exception()) {
      var e = $p;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = todo.r3().m1();
      while (_iterator__ex2g4s_2.n1()) {
        var element_2 = _iterator__ex2g4s_2.o1();
        // Inline function 'kotlin.coroutines.resumeWithException' call
        var this_4 = element_2.bf_1;
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$23 = _Result___init__impl__xyqfz8(createFailure(e));
        this_4.rc(tmp$ret$23);
      }
    } else {
      throw $p;
    }
  }
  return Unit_instance;
}
function fetch($this, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_fetch__osg116.bind(VOID, $this), $completion);
}
var WebsocketChannelClass;
function WebsocketChannel() {
  if (WebsocketChannelClass === VOID) {
    class $ {
      constructor($outer, url) {
        this.peq_1 = $outer;
        this.geq_1 = substringBefore(url, _Char___init__impl__6a9atx(63));
        var tmp = this;
        // Inline function 'kotlin.collections.map' call
        var this_0 = split(substringAfter(url, _Char___init__impl__6a9atx(63), ''), charArrayOf([_Char___init__impl__6a9atx(38)]));
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.m1();
        while (_iterator__ex2g4s.n1()) {
          var item = _iterator__ex2g4s.o1();
          var tmp$ret$0 = to(substringBefore(item, _Char___init__impl__6a9atx(61)), substringAfter(item, _Char___init__impl__6a9atx(61)));
          destination.v(tmp$ret$0);
        }
        // Inline function 'kotlin.collections.groupBy' call
        // Inline function 'kotlin.collections.groupByTo' call
        var destination_0 = LinkedHashMap().f6();
        var _iterator__ex2g4s_0 = destination.m1();
        while (_iterator__ex2g4s_0.n1()) {
          var element = _iterator__ex2g4s_0.o1();
          var key = element.af_1;
          // Inline function 'kotlin.collections.getOrPut' call
          var value = destination_0.p3(key);
          var tmp_0;
          if (value == null) {
            var answer = ArrayList().w();
            destination_0.s3(key, answer);
            tmp_0 = answer;
          } else {
            tmp_0 = value;
          }
          var list = tmp_0;
          var tmp$ret$6 = element.bf_1;
          list.v(tmp$ret$6);
        }
        tmp.heq_1 = destination_0;
        this.ieq_1 = Signal().fak(false);
        this.jeq_1 = Companion_getInstance().m2p().toString();
        this.peq_1.ceq_1.rdn((message) => {
          var tmp;
          if (message.c4q_1 === this.jeq_1) {
            if (message.f4q_1) {
              this.ieq_1.mam(true);
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s = this.meq_1.m1();
              while (_iterator__ex2g4s.n1()) {
                var element = _iterator__ex2g4s.o1();
                element();
              }
            }
            var tmp0_safe_receiver = message.h4q_1;
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_0 = this.neq_1.m1();
              while (_iterator__ex2g4s_0.n1()) {
                var element_0 = _iterator__ex2g4s_0.o1();
                element_0(tmp0_safe_receiver);
              }
            }
            var tmp_0;
            if (message.g4q_1) {
              this.ieq_1.mam(false);
              // Inline function 'kotlin.collections.forEach' call
              var _iterator__ex2g4s_1 = this.oeq_1.m1();
              while (_iterator__ex2g4s_1.n1()) {
                var element_1 = _iterator__ex2g4s_1.o1();
                element_1(-1);
              }
              tmp_0 = Unit_instance;
            }
            tmp = tmp_0;
          }
          return Unit_instance;
        });
        this.peq_1.ceq_1.sdl((it) => {
          this.ieq_1.mam(false);
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s = this.oeq_1.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            element(-1);
          }
          return Unit_instance;
        });
        this.keq_1 = Signal().fak(0);
        var tmp_1 = this;
        // Inline function 'kotlin.apply' call
        var this_1 = CoroutineScope(Job());
        reactiveScope(this_1, ($this$reactiveScope) => {
          var shouldBeOn = $this$reactiveScope.baj(this.keq_1) > 0;
          var isOn = $this$reactiveScope.baj(this.ieq_1);
          var parentConnected = $this$reactiveScope.baj(this.peq_1.ceq_1.odn());
          var tmp;
          if (shouldBeOn && parentConnected && !isOn) {
            this.peq_1.ceq_1.qdn(new (MultiplexMessage())(this.jeq_1, this.geq_1, this.heq_1, true));
            tmp = Unit_instance;
          } else if (!shouldBeOn && parentConnected && isOn) {
            this.peq_1.ceq_1.qdn(new (MultiplexMessage())(this.jeq_1, this.geq_1, this.heq_1, VOID, true));
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        tmp_1.leq_1 = this_1;
        this.meq_1 = ArrayList().w();
        this.neq_1 = ArrayList().w();
        this.oeq_1 = ArrayList().w();
      }
      odn() {
        return this.ieq_1;
      }
      iaj() {
        var _receiver__tnumb7 = this.keq_1;
        var _unary__edvuaz = _receiver__tnumb7.f2();
        _receiver__tnumb7.mam(_unary__edvuaz + 1 | 0);
        var parent = this.peq_1.ceq_1.iaj();
        return () => {
          parent();
          var _receiver__tnumb7 = this.keq_1;
          var _unary__edvuaz = _receiver__tnumb7.f2();
          _receiver__tnumb7.mam(_unary__edvuaz - 1 | 0);
          return Unit_instance;
        };
      }
      ndn(code, reason) {
        this.peq_1.ceq_1.qdn(new (MultiplexMessage())(this.jeq_1, this.geq_1, this.heq_1, VOID, true));
        cancel(this.leq_1);
      }
      pdn(data) {
        this.peq_1.ceq_1.qdn(new (MultiplexMessage())(this.jeq_1, VOID, VOID, VOID, VOID, data));
      }
      qdn(data) {
        return this.pdn((!(data == null) ? typeof data === 'string' : false) ? data : THROW_CCE());
      }
      rdl(action) {
        this.meq_1.v(action);
      }
      tdl(action) {
        this.neq_1.v(action);
      }
      rdn(action) {
        return this.tdl(action);
      }
      qeq(action) {
        throw UnsupportedOperationException().f8();
      }
      udl(action) {
        return this.qeq(action);
      }
      sdl(action) {
        this.oeq_1.v(action);
      }
    }
    initMetadataForClass($, 'WebsocketChannel');
    WebsocketChannelClass = $;
  }
  return WebsocketChannelClass;
}
var BulkFetcher$_init_$slambda_5xatx3Class;
function BulkFetcher$_init_$slambda_5xatx3() {
  if (BulkFetcher$_init_$slambda_5xatx3Class === VOID) {
    class $ {
      sao($completion) {
        // Inline function 'kotlin.collections.listOf' call
        return emptyList();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BulkFetcher$_init_$slambda_5xatx3Class = $;
  }
  return BulkFetcher$_init_$slambda_5xatx3Class;
}
function BulkFetcher$_init_$slambda_5xatx3_0() {
  var i = new (BulkFetcher$_init_$slambda_5xatx3())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var BulkFetcher$invoke$slambdaClass;
function BulkFetcher$invoke$slambda() {
  if (BulkFetcher$invoke$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.deq_1 = this$0;
      }
      wah($this$launch, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$launch), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope_0()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    BulkFetcher$invoke$slambdaClass = $;
  }
  return BulkFetcher$invoke$slambdaClass;
}
function BulkFetcher$invoke$slambda_0(this$0) {
  var i = new (BulkFetcher$invoke$slambda())(this$0);
  var l = ($this$launch, $completion) => i.wah($this$launch, $completion);
  l.$arity = 1;
  return l;
}
var BulkFetcher$fetch$slambdaClass;
function BulkFetcher$fetch$slambda() {
  if (BulkFetcher$fetch$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.eeq_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BulkFetcher$fetch$slambdaClass = $;
  }
  return BulkFetcher$fetch$slambdaClass;
}
function BulkFetcher$fetch$slambda_0(this$0) {
  var i = new (BulkFetcher$fetch$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var BulkFetcher$remember$slambdaClass;
function BulkFetcher$remember$slambda() {
  if (BulkFetcher$remember$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.feq_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    BulkFetcher$remember$slambdaClass = $;
  }
  return BulkFetcher$remember$slambdaClass;
}
function BulkFetcher$remember$slambda_0(this$0) {
  var i = new (BulkFetcher$remember$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var BulkFetcherClass;
function BulkFetcher() {
  if (BulkFetcherClass === VOID) {
    class $ {
      constructor(httpBulk, wsMultiplex, json, pingTime, delay, log, calculator) {
        json = json === VOID ? get_DefaultJson() : json;
        var tmp;
        if (pingTime === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_1();
          tmp = toDuration(5000, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp = pingTime;
        }
        pingTime = tmp;
        var tmp_0;
        if (delay === VOID) {
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance_1();
          tmp_0 = toDuration(100, DurationUnit_MILLISECONDS_getInstance());
        } else {
          tmp_0 = delay;
        }
        delay = tmp_0;
        log = log === VOID ? null : log;
        var tmp_1;
        if (calculator === VOID) {
          tmp_1 = BulkFetcher$_init_$slambda_5xatx3_0();
        } else {
          tmp_1 = calculator;
        }
        calculator = tmp_1;
        this.tep_1 = httpBulk;
        this.uep_1 = wsMultiplex;
        this.vep_1 = json;
        this.wep_1 = pingTime;
        this.xep_1 = delay;
        this.yep_1 = log;
        this.zep_1 = calculator;
        this.aeq_1 = HashMap().n8();
        this.beq_1 = false;
        var tmp_2 = this;
        // Inline function 'kotlin.also' call
        var this_0 = typedWithDebug(retryWebsocket(BulkFetcher$remember$slambda_0(this), _Duration___get_inWholeMilliseconds__impl__msfiry(this.wep_1), VOID, this.yep_1), this.vep_1, Companion_getInstance_0().m2a(), Companion_getInstance_0().m2a());
        var it = this_0;
        if (get_debugMode() && !(this.yep_1 == null)) {
          it.rdl(() => {
            it.qdn(new (MultiplexMessage())('debug', VOID, VOID, true));
            return Unit_instance;
          });
        }
        it.rdn((it) => {
          var tmp;
          if (!(this.yep_1 == null) && it.c4q_1 === 'debug') {
            this.yep_1.fcv(['Multiplex debug: ' + it.toString()]);
            tmp = Unit_instance;
          }
          return Unit_instance;
        });
        tmp_2.ceq_1 = this_0;
      }
      req(calculator) {
        return new (BulkFetcher())(this.tep_1, this.uep_1, this.vep_1, this.wep_1, this.xep_1, this.yep_1, calculator);
      }
      fei(url, method, inSerializer, body, outSerializer, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, url, method, inSerializer, body, outSerializer), $completion);
      }
      sek(url, inSerializer, outSerializer) {
        return typed(new (WebsocketChannel())(this, url), this.vep_1, inSerializer, outSerializer);
      }
    }
    initMetadataForClass($, 'BulkFetcher', VOID, VOID, VOID, [5, 0]);
    BulkFetcherClass = $;
  }
  return BulkFetcherClass;
}
function typedWithDebug(_this__u8e3s4, json, send, receive, log) {
  log = log === VOID ? null : log;
  return new (typedWithDebug$1())(_this__u8e3s4, log, json, receive, send);
}
var typedWithDebug$1Class;
function typedWithDebug$1() {
  if (typedWithDebug$1Class === VOID) {
    class $ {
      constructor($this_typedWithDebug, $log, $json, $receive, $send) {
        this.seq_1 = $this_typedWithDebug;
        this.teq_1 = $log;
        this.ueq_1 = $json;
        this.veq_1 = $receive;
        this.weq_1 = $send;
      }
      odn() {
        return this.seq_1.odn();
      }
      iaj() {
        return this.seq_1.iaj();
      }
      rdl(action) {
        return this.seq_1.rdl(action);
      }
      sdl(action) {
        return this.seq_1.sdl(action);
      }
      rdn(action) {
        this.seq_1.tdl((it) => {
          var tmp;
          if (!(this.teq_1 == null) && startsWith(it, '!!! DEBUG AWS INFO !!! - ')) {
            this.teq_1.fcv(['AWS: ' + substringAfter_0(it, '!!! DEBUG AWS INFO !!! - ')]);
            return Unit_instance;
          }
          var tmp_0;
          try {
            tmp_0 = action(this.ueq_1.y27(this.veq_1, it));
          } catch ($p) {
            var tmp_1;
            if ($p instanceof CancellationException()) {
              var e = $p;
              tmp_1 = Unit_instance;
            } else {
              if ($p instanceof Exception()) {
                var e_0 = $p;
                report(Exception().vd('Failed to decode message; expected a ' + this.veq_1.az().h10() + " but got '" + take(it, 150) + "'", e_0));
                tmp_1 = Unit_instance;
              } else {
                throw $p;
              }
            }
            tmp_0 = tmp_1;
          }
          return Unit_instance;
        });
      }
      qdn(data) {
        this.seq_1.pdn(this.ueq_1.x27(this.weq_1, data));
      }
    }
    initMetadataForClass($);
    typedWithDebug$1Class = $;
  }
  return typedWithDebug$1Class;
}
//region block: exports
export {
  BulkFetcher as BulkFetcher2m111bjvjns8,
};
//endregion

//# sourceMappingURL=BulkFetcher.mjs.map
